import SavingsIcon from '~/shared/assets/icons/savings-icon.svg';
import CircularProgress from '~/shared/components/CircularProgress';
import KPICard from '~/shared/components/KPICard';
import { KPIHeader, KPIMetricGroup, KPIMetricSkeleton } from '~/shared/components/kpi';

export default function MonthlySavingsCard({
  savings,
  potential,
  percentage,
  loading,
}: {
  savings: string;
  potential: string;
  percentage: number;
  loading: boolean;
}) {
  return (
    <KPICard className="min-w-[455px] w-full h-full flex justify-between gap-4">
      <div className="flex flex-col gap-[18px] min-w-0">
        <KPIHeader
          icon={SavingsIcon}
          title="Monthly Savings"
          subtitle="Cost of storage saved by autoscaling"
        />
        <div className="flex items-end mt-auto gap-3 flex-wrap">
          {loading ? (
            <>
              <KPIMetricSkeleton />
              <KPIMetricSkeleton />
            </>
          ) : (
            <>
              <KPIMetricGroup label="Projected Monthly Savings" value={savings} />
              <KPIMetricGroup label="Potential Monthly Savings" value={potential} />
            </>
          )}
        </div>
      </div>
      <div className="flex items-center justify-center">
        <CircularProgress percentage={percentage} loading={loading} size={99} />
      </div>
    </KPICard>
  );
}
